export default {
  mesa: "Table",
  product: "Produit",
  quantity: "Quantité",
  price: "Prix",
  total: "Total du compte",
  totalPaid: "Total payé",
  baseTax: "Assiette fiscale",
  VAT: "T.V.A.",
  paymentMethod: "Mode de paiement",
  pagado: "Payé"
};
